import { useAppState } from "../../context/appStateContext"
import { PurchasProvider } from "../../context/purchaseContext"
import { UltimateAlertsProvider } from "../../context/ultimateAlertsContext"
import AlternativeBottomPaywall from "../AlternativeBottomPaywall/AlternativeBottomPaywall"
import FreeTrialPaywall from "../FreeTrialPaywall/FreeTrialPaywall"
import { FreeTrialPaywallProvider } from "../FreeTrialPaywall/freeTrialPaywallContext"

interface Props {
  freeTrialPaywall: React.ComponentType
}

const ConditionalFreeTrialPaywall = (props: Props) => {
  return (
    <PurchasProvider>
      <UltimateAlertsProvider>
        <FreeTrialPaywallProvider>
          <ConditionalFreeTrialPaywallContent
            freeTrialPaywall={props.freeTrialPaywall}
          />
        </FreeTrialPaywallProvider>
      </UltimateAlertsProvider>
    </PurchasProvider>
  )
}

const ConditionalFreeTrialPaywallContent = (props: Props) => {
  const { state } = useAppState()

  if (!state.fullyLoaded) {
    return <div>Loading</div>
  }

  if (state.productData?.hasTrial) {
    return <props.freeTrialPaywall />
  }

  return <AlternativeBottomPaywall />
}

export default ConditionalFreeTrialPaywall
